import { ChangeDetectorRef, Component, ElementRef, HostListener, ViewChild } from '@angular/core';
import { UserInfoService } from '../../spartacus/services/user-info.service';
import { CustomfilterPipe } from '../../cms-common/Pipes/customfilter.pipe';
import { MatTableDataSource } from '@angular/material/table';
import { FormControl } from '@angular/forms';
import { MatSort, Sort } from '@angular/material/sort';
import { MatPaginator } from '@angular/material/paginator';
import { ApiFailureDialogService } from '../../api-failure-dialog/api-failure-dialog.service';
import { Subject, takeUntil } from 'rxjs';

export interface InvoiceDetail {
  loc: string;
  ordernum: number;
  prodname: string;
  season:string;
  status:string;
  unit:number;

}

@Component({
    selector: 'app-invoice-details-section',
    templateUrl: './invoice-details-section.component.html',
    styleUrls: ['./invoice-details-section.component.scss'],
    standalone: false
})
export class InvoiceDetailsSectionComponent {
  private destroy$ = new Subject<void>();

  ngOnDestroy() {
    this.destroy$.next();
    this.destroy$.complete();
  }

  dropdownValue: any;
  showingLabel: string = "Showing";
  pageSize: number = 6;
  pageSizeControl = new FormControl(6);
  totalLength = 0;
  currentPage: number = 1;
  pageSizeOptions: number[] = [5, 10, 15];
  dataSource:any=[];
  dataSource1= new MatTableDataSource<any>();
  displayedColumns:string[]=['allinvoices'];
  dataSourceWithPageSize = new MatTableDataSource<InvoiceDetail>;
  
  filterValues = {
    search: '',
    filterbyproduct:[],
    filterbystatus:[''],
  
  };
  apiresponse: any;
  @ViewChild('paginator') paginator!: MatPaginator;
  @ViewChild(MatSort)
  sort!: MatSort;
  togglefilterView: boolean=false;
  togglesortView: boolean=false;
  count: any=0;
  getstatus: any;
  selectedstatus: any[]=[];
  firstvalue: string='';
  rightsectionresponse: any;
  isTableHasData: boolean=true;
  isLoading: boolean=false;
  searchText: string='';
  sortedData: any[] = [];
  filteredData1: any;

  
   constructor(private dialogservice:ApiFailureDialogService,public userInfoService:UserInfoService,private cd:ChangeDetectorRef,private eleRef:ElementRef) {
  }
 
  @HostListener('document:click',['$event'])
  onDocumentClick(event:MouseEvent):void{
      /* if(this.togglefilterView){
        if(!this.eleRef.nativeElement.contains(event.target)){
            this.togglefilterView=false;
        }
      
        else {
          if(event.target != this.eleRef.nativeElement.querySelector('filterbox')){
            this.togglefilterView=false;
          }
          else if(event.target === this.eleRef.nativeElement.querySelector('filterbox')){
            this.togglefilterView=true;
          }
        }
      }
      else{
        if(this.eleRef.nativeElement.contains(event.target) && event.target === this.eleRef.nativeElement.querySelector('filterbox')){
          this.togglefilterView=true;
        }
      } */
        if(this.togglefilterView){
          this.togglefilterView =false;
          if(event.target === this.eleRef.nativeElement.querySelector('filterbox')){
            this.togglefilterView = true;
          }
        }
      if(this.togglesortView){
        this.togglesortView =false;
        if(event.target === this.eleRef.nativeElement.querySelector('sortbox')){
          this.togglesortView = true;
        }
      }
    
  }

  ngOnInit() {
    this.getstatus = [ "UNPAID", "DUE SOON", "OVERDUE", "PAID" ];
  
    this.userInfoService.getDropdownValue().pipe(takeUntil(this.destroy$)).subscribe(
      value => {
        this.isLoading = true;
        this.dropdownValue = value;
        
        if (!this.dropdownValue) {
          this.isLoading = false;
          this.cd.detectChanges();
        }

        this.searchText = '';
        this.sortedData = [];
  
        const searchField = document.getElementById("invoice_search") as HTMLInputElement;
        if (searchField) {
          searchField.value = '';
        }
  if(this.dropdownValue){
        this.userInfoService.getAllInvoices(this.dropdownValue).subscribe(
          value => {

            if(value?.errorCode=="500" && localStorage.getItem('FailureDailog') != 'true'){
              this.dialogservice.openErrorDialog();
              localStorage.setItem('FailureDailog', 'true');
              this.isLoading=false;
              this.cd.detectChanges();
            }
            const body = <HTMLElement>document.querySelector("body");
            // body.classList.add("loadingparent");
  
            console.log(value.invoiceList.paidInvoiceCount);
            this.userInfoService.setPaidInvoiceCount(value.invoiceList?.paidInvoiceCount);
            this.userInfoService.setInvoiceCount(value.invoiceList?.openInvoiceCount);
            this.cd.detectChanges();
  
            let invoiceListuk = JSON.parse(value.invoiceListJson);
            this.apiresponse = invoiceListuk.invoices;
            this.dataSource = new MatTableDataSource(this.apiresponse);
            this.dataSourceWithPageSize = new MatTableDataSource(this.apiresponse);
            this.resetFilter();
            this.dataSource.paginator = this.paginator;
            this.dataSource.sort = this.sort;
            this.resetSort();
            this.totalLength = this.apiresponse.length;
            this.updateTableData();
  
            this.dataSource.sortingDataAccessor = (item: any, property: any) => {
              switch (property) {
                case 'invoiceDateSorting':
                  return new Date(item.invoiceDateSorting);
                default:
                  return item[property];
              }
            };
  
            this.firstvalue = this.apiresponse[0]?.invoiceNumber;
  
            if (this.firstvalue && this.firstvalue !== 'N/A') {
              this.openrightsection(this.firstvalue, this.apiresponse[0].status);
            }
  
            this.isLoading = false;
            this.cd.detectChanges();
          },
          error => {
            console.error('Error fetching invoice data:', error);
            this.isLoading = false;
            this.cd.detectChanges();
          }
        );
      }
      },
    
      error => {
        console.error('Error fetching dropdown value:', error);
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
  }

  updateTableData() {
    const starti = (this.currentPage - 1) * this.pageSize;
    const endi = starti + this.pageSize;
    //this.dataSource.data = this.apiresponse.slice(starti, endi);
    if(this.sortedData.length) {
      this.dataSource.data = this.sortedData.slice(starti, endi);
     } 
     else {
       if(this.filteredData1?.length >0){
         this.dataSource.data = this.filteredData1.slice(starti, endi);
 
       }else{
         this.dataSource.data = this.apiresponse.slice(starti, endi);
       }
     }
  }

  inputSearch(event:Event){
    this.searchText = (event.target as HTMLInputElement).value;
    this.dataSource.filter = this.searchText || ''.trim().toLowerCase();
    this.dataSource.paginator = this.paginator;
    if(this.dataSource.paginator){
      this.dataSource.paginator.firstPage()
    }
    if(this.dataSource.filteredData.length > 0){
      this.isTableHasData = true;
      }
      else{
        this.isTableHasData = false;
      }
    

  }
  applyFilter() {
     
    this.filteredData1 = new CustomfilterPipe().transform(this.apiresponse, this.filterValues);
   this.dataSource = new MatTableDataSource(this.filteredData1);
   this.cd.detectChanges();
   this.dataSourceWithPageSize = new MatTableDataSource(this.apiresponse);
    this.dataSource.paginator = this.paginator;
       this.dataSource.sort = this.sort; 
   this.totalLength = this.filteredData1.length;
   this.currentPage=1;
   const starti = (this.currentPage - 1) * this.pageSize;
   const endi = starti + this.pageSize;
   this.dataSource.data = this.filteredData1.slice(starti, endi); 
  
  }
  
  filteropen(){
    event?.stopPropagation();
    this.togglefilterView=!this.togglefilterView;
    this.togglesortView=false;
  }
  sortopen(){
    event?.stopPropagation();
    this.togglefilterView=false;
    this.togglesortView=!this.togglesortView;
    
  } 
  resetFilter(){
    this.selectedstatus=[];
    this.count =0;
    const statusCheckboxes = document.querySelectorAll('.invoice_checkbox');
    statusCheckboxes.forEach((ch)=>{
      (ch as HTMLInputElement).checked=false;
    });
    this.filterValues.filterbystatus=this.selectedstatus;
    this.applyFilter();
  }
  resetSort(){
    const statusCheckboxes = document.querySelectorAll('.invoice_radio');
    statusCheckboxes.forEach((ch)=>{
      (ch as HTMLInputElement).checked=false;
    });
    const sortState: Sort = {active: '', direction: ''};    
    this.dataSource.sort = this.sort; 
    /* this.sort.active = sortState.active;
    this.sort.direction = sortState.direction; */
    //this.sort.sortChange.emit(sortState);
  }
  incrementcountstatus(event:any,i:number){
   
    if (event.target.checked) {

      this.count++;
      this.selectedstatus.push(event.target.value);
      this.filterValues.filterbystatus=this.selectedstatus;
     
    } else {
      var index = this.selectedstatus.indexOf(event.target.value);
      this.selectedstatus.splice(index, 1);
      this.filterValues.filterbystatus=this.selectedstatus;
     this.count--;
    } 
  } 

  sortTest(val:any){
    
    let newdir :string = 'desc'
    if(val == '1to9' || val == '9to1'){
    const sortState: Sort = {active: 'invoiceNumber', direction: val == '1to9'?'asc': 'desc'};    
    this.sort.active = sortState.active;
    this.sort.direction = sortState.direction;
    this.sort.sortChange.emit(sortState);
    this.dataSource.sort = this.sort;
    this.cd.detectChanges();
   
    }
    else if(val == 'AtoZ' || val == 'ZtoA'){
      const sortState: Sort = {active: 'location', direction: val == 'AtoZ'?'asc': 'desc'};    
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);
      this.dataSource.sort = this.sort;
      
    }
    else if(val == 'LeastRecent' || val == 'MostRecent'){
      
      const sortState: Sort = {active: 'invoiceDateSorting', direction: val == 'LeastRecent'?'asc': 'desc'};    
      this.sort.active = sortState.active;
      this.sort.direction = sortState.direction;
      this.sort.sortChange.emit(sortState);
      this.dataSource.sort = this.sort;
     
    }
    this.updateDataSource();
  }
  updateDataSource() {

    const sortDirection = this.sort.direction;
    const activeColumn = this.sort.active;
  
    // Create a copy of the original data array
    this.sortedData = [...this.apiresponse];
  
    //if filtered data present,apply sort to filtered data
    if(this.filteredData1?.length > 0){
      this.sortedData = [...this.filteredData1];
    }
  
    // Sort the data based on the current sort direction and active column
    if (sortDirection && activeColumn) {
      this.sortedData.sort((a, b) => {
        const isAsc = sortDirection === 'asc';
        if(activeColumn == 'invoiceDateSorting'){
          a[activeColumn] = new Date(a[activeColumn]);
          b[activeColumn] = new Date(b[activeColumn]);
        }
        return this.compare(a[activeColumn], b[activeColumn], isAsc);
      });
    }
    this.currentPage=1;
     const startIndex = (this.currentPage - 1) * this.pageSize;
     const endIndex = startIndex + this.pageSize;
    const paginatedData = this.sortedData.slice(startIndex, endIndex); 
  
    // Update the dataSource with the sorted data
    this.dataSource.data = paginatedData;
    
  }

   // Helper function for sorting
   compare(a: string | number, b: string | number, isAsc: boolean) {
    return (a < b ? -1 : 1) * (isAsc ? 1 : -1);
  }
  

  openrightsection(invoiceId:string, status:string){
    this.rightsectionresponse=null;
    this.firstvalue=invoiceId;
    const temp= <HTMLElement>document.getElementsByClassName("activeinvoice")[0];
    if(temp){
    temp.classList.remove("activeinvoice");
    }
    const temp1= <HTMLElement> <unknown>document.getElementById(invoiceId);
    if(temp1){
    temp1.classList.add('activeinvoice');
    }
    this.isLoading = true;
    
    this.userInfoService.AllInvoicesRightsection(this.dropdownValue, invoiceId, status).subscribe(
      value => {
        this.rightsectionresponse = value;
        this.isLoading = false;
        this.cd.detectChanges();
      },
      error => {
        console.error('Error fetching AllInvoicesRightsection data:', error);
        this.isLoading = false;
        this.cd.detectChanges();
      }
    );
    
  }

  downloadInvoice(invoicenum : string) {  
     this.isLoading = true;
    
     this.userInfoService.downloadInvoiceApi(invoicenum).
     subscribe((data: ArrayBuffer) => {
          
          // this.cd.detectChanges()
           // Create a Blob from the ArrayBuffer
           const file = new Blob([data], { type: 'application/pdf' });
           const fileURL = URL.createObjectURL(file);
           //window.open(fileURL); // Open in a new tab
  
           const a = document.createElement('a');
           a.href = fileURL;
           a.target = '_blank';
           a.download = invoicenum;
           document.body.appendChild(a);
           a.click();
       
          this.isLoading = false;
          this.cd.detectChanges()
         },
        
         (error) => {
         
          this.isLoading = false;
           this.cd.detectChanges()
         }
         
       );
  
  }

  onPageSizeChange(event: any) {
    this.pageSize = parseInt(event.target.value, 10);
    this.currentPage = 1;
    this.updateTableData();
  }
  goToLastPage() {
    const totalPages = Math.ceil(this.totalLength / this.pageSize);
    this.currentPage = totalPages;
    this.updateTableData();
  } 
  scrollToTop(): void { 
    window.scrollTo({ top: 0, behavior: 'smooth' });
   }
 
   goToFirstPage() {
    this.currentPage = 1;
    this.updateTableData();
  }
  
  getPages(): any {
    const totalPages = Math.ceil(this.totalLength / this.pageSize);
    const pages: any = [];
    const startPage = Math.max(1, this.currentPage - 1);
    const endPage = Math.min(totalPages, startPage + 2);
 
    for (let i = startPage; i <= endPage; i++) {
      pages.push(i);
 
 
    }
    if (endPage < totalPages - 1) {
      pages.push('...');
    }
    if (endPage < totalPages) {
      pages.push(totalPages);
    }
    return pages;
  }
   goToPage(page: number) {
    this.currentPage = page;
    const starti = (page - 1) * this.pageSize;
    //this.dataSource.data = this.apiresponse.slice(starti, starti + this.pageSize);
    if(this.sortedData.length) {
      this.dataSource.data = this.sortedData.slice(starti, starti + this.pageSize);
    } 
    else {
      if(this.filteredData1?.length >0){
        this.dataSource.data = this.filteredData1.slice(starti, starti + this.pageSize);

      }else{
        this.dataSource.data = this.apiresponse.slice(starti, starti + this.pageSize);
      }
    }
  } 
   previousPage() {
    if (this.currentPage > 1) {
      this.goToPage(this.currentPage - 1);
    }
  } 
     nextPage() {
    const totlpages = Math.ceil(this.totalLength / this.pageSize);
    if (this.currentPage < totlpages) {
      this.goToPage(this.currentPage + 1);
    }
  } 
  isFirstPage(): boolean {
    return this.currentPage == 1;
  }
  isLastPage(): boolean {
    return this.currentPage == Math.ceil(this.totalLength / this.pageSize);
  }
  isCurrentPage(page: number): boolean {
    return this.currentPage == page;
  }

  onFilterClick(event:Event){
    event.stopPropagation();
  }

}
